import { useEffect, useRef, useState } from "react";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../assets/toastUtils";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../Header/Header";
import NewSearchSateInput from "../../../NewSearchSateInput/NewSearchSateInput";
import Flatpickr from "react-flatpickr";
import styles from "./EditNewUiSearchFormHotels.module.scss";
import {
  calculateToDatePlus,
  currentDateSingle,
  getDateByMonth,
} from "../../../../utils/utils";
import PackagesStateInputNewUi from "../../../PackagesStateInput/PackagesStateInputNewUi";
import { SvgMan, SvgSearch } from "../../../../utils/svgIcons";

import DatePicker from "react-datepicker";
import { format, addDays } from "date-fns";
import NewMultiSelectSearchHolidays from "../../../NewSearchSateInput/NewMultiSelectSearchHolidays";
import GuestDetailsPopup from "./GuestDetailsPopup";
import { toast } from "react-toastify";

function EditNewUiSearchFormHotels({
  searchType,
  singleHotelPage,
  singleHotelData,
  handleRoomsChange,
}) {
  const [modifyPkg, setModiyPkg] = useState(false);
  const [mobileHead, setMobileHead] = useState(false);
  const toggleModify = () => {
    setModiyPkg(!modifyPkg);
  };
  const [dataFromChild, setDataFromChild] = useState("");
  const [destinationToggle, setdestinationToggle] = useState(false);
  const [selectedMultipleDestinations, setSelectedMultipleDestinations] =
    useState([]);

  const getDataFromChild = (data, resultArray) => {
    setDataFromChild(data);
    // setStateResultArray(resultArray)
    // console.log(resultArray);
  };
  // console.log(dataFromChild, "getDataFromChild");

  const [guestDetails, setIsguestDetails] = useState(false);

  const dropdownGuestDetails = () => {
    setIsguestDetails((prev) => !prev);
  };
  const [SelectedroomsData, selectedSetRoomsData] = useState([]);

  const handleRoomsUpdate = (updatedRooms) => {
    selectedSetRoomsData(updatedRooms);
  };

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [data, setData] = useState({ fromCity: "", toCity: "" });

  const showErrorToast = (message) => {
    alert(message);
  };

  const [bookingData, setBookingData] = useState({});
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const checkinDay = queryParams.get("checkinDay") || "";
  const checkinMonth = queryParams.get("checkinMonth") || "";
  const checkinYear = queryParams.get("checkinYear") || "";
  const checkoutDay = queryParams.get("checkoutDay") || "";
  const checkoutMonth = queryParams.get("checkoutMonth") || "";
  const checkoutYear = queryParams.get("checkoutYear") || "";

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const childAges = [];
    let i = 1;

    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    const data = {
      hotelID: params.get("hotelID"),
      location: params.get("location"),
      room: params.get("room"),
      adult: params.get("adult"),
      children: params.get("children"),
      checkinDay: params.get("checkinDay"),
      checkinMonth: params.get("checkinMonth"),
      checkinYear: params.get("checkinYear"),
      checkoutDay: params.get("checkoutDay"),
      checkoutMonth: params.get("checkoutMonth"),
      checkoutYear: params.get("checkoutYear"),
      radio: params.get("radio"),
      childAge: childAges,
      multiple_destinations: params.get("selected_destinations"),
    };

    const checkInDate = `${data.checkinYear}-${String(
      data.checkinMonth
    ).padStart(2, "0")}-${String(data.checkinDay).padStart(2, "0")}`;
    const checkOutDate = `${data.checkoutYear}-${String(
      data.checkoutMonth
    ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    setData({
      fromCity: params.get("location"),
      // toCity: params.get("location"),
    });

    setAdults(data.adult ? data.adult : 2);
    setChildren(data.children ? data.children : 0);
    setRooms(data.room ? data.room : 1);
    setChildAge(childAges);
    setSelectedMultipleDestinations(
      data.multiple_destinations
        ?.split(",")
        ?.map((item) => item.trim())
        ?.filter((item) => item !== "")
    );

    if (!data.checkinDay) {
      // setStartDate(currentDateSingle);
      // setEndDate(calculateToDatePlus(currentDateSingle, 3));

      setStartDate(calculateToDatePlus(currentDateSingle, 7));
      setEndDate(calculateToDatePlus(currentDateSingle, 8));
    } else {
      setStartDate(checkInDate);
      setEndDate(checkOutDate);
    }

    setBookingData(data);
    // postBookingData(data);
  }, [location.search]);

  const [checkin, setCheckin] = useState({
    day: checkinDay,
    month: checkinMonth,
    year: checkinYear,
  });

  const [checkout, setCheckout] = useState({
    day: checkoutDay,
    month: checkoutMonth,
    year: checkoutYear,
  });
  const navigate = useNavigate();

  // STATES
  // const [startDate, setStartDate] = useState(new Date());
  // const [endDate, setEndDate] = useState(calculateToDatePlus(new Date(), 1));

  const [startDate, setStartDate] = useState(() => {
    const start = new Date();
    start.setDate(start.getDate() + 7);
    return start;
  });

  // End date is 8 days from today (1 day after start)
  const [endDate, setEndDate] = useState(() => {
    const end = new Date();
    end.setDate(end.getDate() + 8);
    return end;
  });

  const [date, setDate] = useState(new Date());
  const [hotelData, setHotelData] = useState([]);

  const [selectedRadio, setSelectedRadio] = useState("");

  //
  const [adult, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [rooms, setRooms] = useState(1);
  const [childAge, setChildAge] = useState([]);

  // Date alterations
  const [loader, setLoader] = useState(false);

  const dropdownRef = useRef(null); // Reference for the popup

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsguestDetails(false); //  Close popup when clicking outside
    }
  };

  useEffect(() => {
    if (guestDetails) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [guestDetails]);

  // functions for increase decrease
  // const onChildDecrease = (e) => {
  //   e.preventDefault();
  //   const updatedChildren = Number(children) - 1;
  //   setChildren(updatedChildren);
  //   const updatedAges = childAge.slice(0, childAge.length - 1);
  //   setChildAge(updatedAges);
  // };

  // const onChildIncrease = (e) => {
  //   e.preventDefault();
  //   const updatedChildren = Number(children) + 1;
  //   setChildren(updatedChildren);
  //   setChildAge([...childAge, ""]);
  // };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
  };

  const handleChildrenAgeChange = (index, event) => {
    const updatedAges = [...childAge];
    const ageValue = event.target.value.replace(/[^0-9]/g, "");

    if (ageValue > 12) {
      showErrorToast("Age should be less than or equal to 12");
      return;
    }

    updatedAges[index] = ageValue !== "" ? parseInt(ageValue, 10) : "";
    setChildAge(updatedAges);
  };

  const handleSubmitButtonClickHandlerListingHotels = async (e) => {
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      alert("Child age must be between 0 and 12");
      return;
    }
    setLoader(true);
    setModiyPkg(false);

    try {
      await navigate(
        `/listing-hotels?location=${
          bookingData?.location && !bookingData.location != null
            ? bookingData?.location
            : dataFromChild
        }&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkinDay=${new Date(
          startDate
        ).getDate()}&checkinMonth=${
          new Date(startDate).getMonth() + 1
        }&checkinYear=${new Date(
          startDate
        ).getFullYear()}&checkoutDay=${new Date(
          endDate
        ).getDate()}&checkoutMonth=${
          new Date(endDate).getMonth() + 1
        }&checkoutYear=${new Date(
          endDate
        ).getFullYear()}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&radio=${
          bookingData.radio
        }&selected_destinations=${selectedMultipleDestinations}`,
        // {
        //   state: {
        //     storeRoomsData: storeRoomsData
        //       ? storeRoomsData
        //       : updatedStoreRoomsData,
        //   },
        // },
        // `/searchresults?hotelID=&location=${property_city}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}#hotels`,
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
      setModiyPkg(false);
    } finally {
      setLoader(false);
    }
  };
  const handleSubmitButtonClickHandlerListingHotelsAllHotels = async (e) => {
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      alert("Child age must be between 0 and 12");
      return;
    }
    setLoader(true);
    setModiyPkg(false);

    try {
      await navigate(
        `/listing-hotels?location=${
          bookingData?.location && !bookingData.location != null
            ? bookingData?.location
            : dataFromChild
        }&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkinDay=${new Date(
          startDate
        ).getDate()}&checkinMonth=${
          new Date(startDate).getMonth() + 1
        }&checkinYear=${new Date(
          startDate
        ).getFullYear()}&checkoutDay=${new Date(
          endDate
        ).getDate()}&checkoutMonth=${
          new Date(endDate).getMonth() + 1
        }&checkoutYear=${new Date(
          endDate
        ).getFullYear()}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&radio=${
          bookingData.radio
        }&selected_destinations=${
          bookingData?.location && !bookingData.location != null
            ? bookingData?.location
            : dataFromChild
        }`,
        // {
        //   state: {
        //     storeRoomsData: storeRoomsData
        //       ? storeRoomsData
        //       : updatedStoreRoomsData,
        //   },
        // },
        // `/searchresults?hotelID=&location=${property_city}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}#hotels`,
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
      setModiyPkg(false);
    } finally {
      setLoader(false);
    }
  };
  const handleSubmitButtonSingleHotel = async (e) => {
    if (e) {
      e.preventDefault();
    }

    // check children age exists

    if (childAge.some((age) => age === "")) {
      showErrorToast("Please enter age for all children");
      return;
    }

    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      alert("Child age must be between 0 and 12");
      return;
    }

    setLoader(true);
    setModiyPkg(false);

    try {
      await navigate(
        `/single-hotel/${singleHotelData?.slug}/${
          singleHotelData?.hotelId
        }?location=${
          bookingData?.location
        }&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkinDay=${new Date(
          startDate
        ).getDate()}&checkinMonth=${
          new Date(startDate).getMonth() + 1
        }&checkinYear=${new Date(
          startDate
        ).getFullYear()}&checkoutDay=${new Date(
          endDate
        ).getDate()}&checkoutMonth=${
          new Date(endDate).getMonth() + 1
        }&checkoutYear=${new Date(
          endDate
        ).getFullYear()}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&radio=${
          bookingData.radio
        }&selected_destinations=${selectedMultipleDestinations}`,
        // {
        //   state: {
        //     storeRoomsData: storeRoomsData,
        //   },
        // },
        // &hotel_name=Golden%20Fern%20Resort%20Shimla&hotel_address=Kachi%20Ghatti,%20Shimla,%20Himachal%20Pradesh%20171010`,

        //  `/searchresults?hotelID=&location=${property_city}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}#hotels`,
        undefined,
        { shallow: false }
      );
      // await navigate(
      //   `/single-hotel?location=${dataFromChild}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkinDay=${new Date(
      //     startDate
      //   ).getDate()}&checkinMonth=${
      //     new Date(startDate).getMonth() + 1
      //   }&checkinYear=${new Date(
      //     startDate
      //   ).getFullYear()}&checkoutDay=${new Date(
      //     endDate
      //   ).getDate()}&checkoutMonth=${
      //     new Date(endDate).getMonth() + 1
      //   }&checkoutYear=${new Date(
      //     endDate
      //   ).getFullYear()}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&radio=${
      //     bookingData.radio
      //   }`,
      //   // `/searchresults?hotelID=&location=${property_city}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}#hotels`,
      //   undefined,
      //   { shallow: false }
      // );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
      setModiyPkg(false);
    } finally {
      setLoader(false);
    }
  };

  const handleSubmitButtonClickHandler = async (e) => {
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      return;
    }

    setLoader(true);
    setModiyPkg(false);

    try {
      await navigate(
        `/listing-hotels?hotelID=1&location=${
          bookingData?.location
        }&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkinDay=${new Date(
          startDate
        ).getDate()}&checkinMonth=${
          new Date(startDate).getMonth() + 1
        }&checkinYear=${new Date(
          startDate
        ).getFullYear()}&checkoutDay=${new Date(
          endDate
        ).getDate()}&checkoutMonth=${
          new Date(endDate).getMonth() + 1
        }&checkoutMonth=${new Date(
          endDate
        ).getFullYear()}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&radio=${selectedRadio}&selected_destinations=${selectedMultipleDestinations}`,
        // {
        //   state: {
        //     storeRoomsData: storeRoomsData,
        //   },
        // },

        // `/searchresults?hotelID=&location=${property_city}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}#hotels`,
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
      setModiyPkg(false);
    } finally {
      setLoader(false);
    }
  };

  const handleSubmitButtonClickHandlerAllHotels = async (e) => {
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      alert("Child age must be between 0 and 12");
      return;
    }
    setLoader(false);
    setModiyPkg(false);

    try {
      await navigate(
        `/all-hotels?location=${bookingData?.location}&selected_destinations=${selectedMultipleDestinations}`,
        // `/searchresults?hotelID=&location=${property_city}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}#hotels`,
        undefined,
        { shallow: false }
        // {
        //   state: {
        //     storeRoomsData: storeRoomsData,
        //   },
        // }
      );
      setModiyPkg(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
      setModiyPkg(false);
    } finally {
      setLoader(false);
    }
  };

  const storeRoomsData = JSON.parse(
    decodeURIComponent(queryParams.get("storeRoomsData"))
  );

  // popup details
  const queryRoomsData = queryParams.get("storeRoomsData");
  const parsedRoomsData = queryRoomsData
    ? JSON.parse(decodeURIComponent(queryRoomsData))
    : JSON.parse(localStorage.getItem("storeRoomsData")) || [];

  useEffect(() => {}, []);

  const [updatedStoreRoomsData, setUpdatedStoreRoomsData] =
    useState(parsedRoomsData);

  useEffect(() => {
    if (searchType === "all_hotels") {
      setUpdatedStoreRoomsData([
        {
          id: 1,
          adult: 2,
          children: [],
        },
      ]);
    }
    return () => {
      if (searchType === "all_hotels") {
        localStorage.removeItem("storeRoomsData");
      }
    };
  }, []);

  useEffect(() => {
    if (updatedStoreRoomsData.length > 0) {
      localStorage.setItem(
        "storeRoomsData",
        JSON.stringify(updatedStoreRoomsData)
      );
      setRooms(updatedStoreRoomsData.length);
    }
  }, [updatedStoreRoomsData]);

  useEffect(() => {
    if (typeof handleRoomsChange === "function") {
      handleRoomsChange(updatedStoreRoomsData);
    }
  }, [updatedStoreRoomsData]);

  const addRoom = () => {
    setUpdatedStoreRoomsData((prevRooms) => {
      if (prevRooms.length >= 6) return prevRooms;

      const newRoomId =
        prevRooms.length > 0 ? prevRooms[prevRooms.length - 1].id + 1 : 1;
      const newRooms = [
        ...prevRooms,
        { id: newRoomId, adult: 1, children: [] },
      ];

      setRooms(newRooms.length);
      updateTotalAdults(newRooms);

      return newRooms;
    });
  };
  const removeRoom = (roomId) => {
    setUpdatedStoreRoomsData((prevRooms) => {
      const filteredRooms = prevRooms.filter((room) => room.id !== roomId);

      setRooms(filteredRooms.length);
      updateTotalAdults(filteredRooms);

      const childrens = filteredRooms.flatMap((room) => room?.children || []);
      setChildren(childrens.length);

      return filteredRooms;
    });
  };

  const updateTotalAdults = (updatedRooms) => {
    const totalAdults = updatedRooms?.reduce(
      (sum, room) => sum + room.adult,
      0
    );
    setAdults(totalAdults);
  };

  const onAdultIncrease = (roomId) => {
    const updatedRooms = updatedStoreRoomsData?.map((room) =>
      room.id === roomId
        ? { ...room, adult: Math.min(room.adult + 1, 4) }
        : room
    );
    setUpdatedStoreRoomsData(updatedRooms);
    updateTotalAdults(updatedRooms);
  };

  const onAdultDecrease = (roomId) => {
    const updatedRooms = updatedStoreRoomsData?.map((room) =>
      room.id === roomId
        ? { ...room, adult: Math.max(room.adult - 1, 1) }
        : room
    );
    setUpdatedStoreRoomsData(updatedRooms);
    updateTotalAdults(updatedRooms);
  };

  const addChildAge = (roomId, age) => {
    const room = updatedStoreRoomsData.find((room) => room.id === roomId);
    if (room && room.children.length >= 3) {
      toast.error("You can add a maximum of 3 children in one room.");
      return;
    }

    setUpdatedStoreRoomsData((prevRooms) =>
      prevRooms.map((room) =>
        room.id === roomId
          ? room.children.length < 3
            ? {
                ...room,
                children: [...room.children, age],
                showGuestDetailsPopup: !room.showGuestDetailsPopup,
              }
            : room
          : room
      )
    );

    // if (childAge.length < 3) {
    setChildren(Number(children) + 1);
    setChildAge([...childAge, age]);
    // }
  };

  const removeChild = (roomId, indexToRemove) => {
    setUpdatedStoreRoomsData((prevRooms) => {
      const updatedRooms = prevRooms.map((room) => {
        if (room.id === roomId) {
          return {
            ...room,
            children: room.children.filter(
              (_, index) => index !== indexToRemove
            ),
          };
        }
        return room;
      });

      const newChildAges = updatedRooms.flatMap((room) => room.children);

      // Update the childAge state
      setChildAge(newChildAges);

      return updatedRooms;
    });

    setChildren((prev) => Number(prev) - 1);
  };

  const toggleGuestDetailsPopup = (roomId) => {
    setUpdatedStoreRoomsData((prevRooms) =>
      prevRooms.map((room) =>
        room.id === roomId
          ? { ...room, showGuestDetailsPopup: !room.showGuestDetailsPopup }
          : room
      )
    );
  };
  // end popup details

  const handleDateChange = ([start, end]) => {
    // setDateRange([start, end]);
    setStartDate(start);
    setEndDate(end);
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [height, setHeight] = useState(window.innerHeight);

  // useEffect(() => {
  //   if (window.innerWidth <= 640) {
  //     setMobileHead(true);

  //   } else {
  //     setMobileHead(false);
  //   }

  // }, [width]);
  // console.log("mobileHead", mobileHead);

  //   useEffect(() => {
  //     if (window.innerWidth <= 640) {
  //         setMobileHead(true);
  //     } else {
  //         setMobileHead(false);
  //     }
  // }, []);

  const updateDimensions = () => {
    // console.log("window.innerWidth", window.innerWidth);

    if (width > 640) {
      setMobileHead(false);
    } else {
      setMobileHead(true);
    }
  };

  useEffect(() => {
    // Call the function on initial render
    // updateDimensions();

    // Add event listener for window resize
    window.addEventListener("resize", updateDimensions);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", updateDimensions);
  }, [width]);
  // console.log(endDate, 'endDate');

  const handleMultiDestinationsChange = (selected) => {
    setSelectedMultipleDestinations(selected);
  };

  return (
    <section
      className={styles.EditSearchParentWrapper}
      id="HotelEditSearchForm"
    >
      <div className={styles.singleSearch} id="singleSearch">
        {/* {singleHotelPage ? ( */}
        {searchType === "hotel_listing" && (
          <form
            action=""
            className={styles.EditSearchFormWrapper}
            id="main-form"
            onSubmit={
              searchType === "hotel_listing"
                ? handleSubmitButtonClickHandlerListingHotels
                : handleSubmitButtonClickHandler
            }
          >
            {/* {width} */}
            {width <= 640 ? (
              <>
                {/* <div className={styles.EditSearchParentWrapperMobile}>
                  <div className="flex_align_center">
                    <span onClick={() => window.history.back()}>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM1 9H16V7H1V9Z"
                          fill="#333333"
                        />
                      </svg>
                    </span>
                    <div className="SingleSearch-resp_content">
                      <h4 style={{ fontSize: "16px", lineHeight: "20px" }}>
                        {data?.fromCity ? (
                          capitalizeFirstLetter(data.fromCity)
                        ) : (
                          <p>Enter a destination</p>
                        )}
                      </h4>
                      <div style={{ fontSize: "14px", lineHeight: "20px" }}>
                        <span>{endDate}</span>
                        <span> | </span>
                        <span>
                          {adult} Adult, {children} Child
                        </span>
                      </div>
                    </div>
                  </div>
                  <div onClick={toggleModify}>
                    {modifyPkg ? (
                      <span style={{ marginRight: "10px" }}>X</span>
                    ) : (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_2797_7470"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="20"
                          height="20"
                        >
                          <rect width="20" height="20" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_2797_7470)">
                          <path
                            d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM2.5 17.5V13.9583L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.04167 17.5H2.5ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z"
                            fill="#333333"
                          />
                        </g>
                      </svg>
                    )}
                  </div>
                </div> */}

                <div className={styles.mobile_new_wrapper_container}>
                  <div
                    onClick={toggleModify}
                    className={styles.mobile_new_wrapper}
                  >
                    <div className={styles.mobile_new_left_div}>
                      <div>
                        {" "}
                        <SvgSearch />
                      </div>
                      <div className={styles.mobile_new_left_div_location}>
                        {data.fromCity &&
                          data.fromCity !== "" &&
                          data.fromCity != null &&
                          data.fromCity != "null" &&
                          capitalizeFirstLetter(data.fromCity) + ", "}
                        <span>
                          {getDateByMonth(startDate) +
                            " - " +
                            getDateByMonth(endDate) +
                            ""}
                        </span>
                      </div>
                    </div>

                    <div className={styles.mobile_new_right_div}>
                      <div className={styles.mobile_new_right_div_svg}>
                        <SvgMan />
                      </div>
                      <div className={styles.mobile_new_right_div_guest}>
                        {adult}
                      </div>
                    </div>
                  </div>

                  {modifyPkg && (
                    <div className={styles.lower_form}>
                      <div>
                        {/* <label htmlFor="">City/Destination</label> */}
                        {/* <GooglePlaceApi
                        setSelectedLocation={setSelectedLocation}
                        data={data}
                        defaultValue={data?.fromCity && data.fromCity}
                        setData={setData}
                        showErrorToast={showErrorToast}
                        position={"SingleSearchForm"}
                      /> */}
                        <label htmlFor="">City/Destination</label>
                        {/* <PackagesStateInputNewUi
                          onDataChange={getDataFromChild}
                          width={width}
                          // disableSearchInput={true}
                        /> */}
                        <NewMultiSelectSearchHolidays
                          onClick={() => setdestinationToggle(true)}
                          onMultiSelectionChange={handleMultiDestinationsChange}
                          // selectedMultipleDestinations={selectedMultipleDestinations}
                          defaultSelected={selectedMultipleDestinations}
                          className={"search_form_input"}
                        />
                      </div>
                      <div className="new_date_picker_react_js_custom_styling">
                        <label>Check In - Check Out</label>
                        <DatePicker
                          selected={startDate}
                          onChange={(dates) => {
                            const [start, end] = dates;
                            setStartDate(start);
                            setEndDate(end);
                          }}
                          startDate={startDate}
                          endDate={endDate}
                          selectsRange
                          portalId="root-portal NewUIReactDatePicker"
                          popperPlacement="bottom-start"
                          minDate={new Date()} // Prevent past dates selection
                          dateFormat="dd MMM, yyyy"
                          placeholderText={`${format(
                            startDate,
                            "dd MMM, yyyy"
                          )} - ${format(endDate, "dd MMM, yyyy")}`}
                        />
                      </div>
                      <div className="search_form_div p_0 icon_button_only">
                        <label
                          onClick={dropdownGuestDetails}
                          className="search_label"
                        >
                          Room & Guests{" "}
                          <svg
                            width="9"
                            height="5"
                            viewBox="0 0 9 5"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.25 0.75L4.75 4.25L1.25 0.75"
                              stroke="#BB735D"
                            />
                          </svg>
                        </label>
                        <p
                          style={{ position: "relative" }}
                          className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                        >
                          <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                            <div className="optionCounter"></div>
                            <span id="adult_count">{adult}</span>
                            <span> Adults,</span>{" "}
                            <span id="room_count">{rooms}</span>
                            <span> Rooms, </span>{" "}
                            <span id="child_count">{children}</span>
                            <span> Children</span>
                          </div>
                          {guestDetails && (
                            <div ref={dropdownRef} className="popup-container">
                              <GuestDetailsPopup
                                setIsguestDetails={setIsguestDetails}
                                buttonName="Modify"
                                adult={adult}
                                setAdults={setAdults}
                                children={children}
                                setChildren={setChildren}
                                rooms={updatedStoreRoomsData}
                                setRooms={setUpdatedStoreRoomsData}
                                onRoomsChange={setUpdatedStoreRoomsData}
                                handleRoomsUpdate={setUpdatedStoreRoomsData}
                                setChildAge={setChildAge}
                                onAdultChange={setAdults}
                                childAge={childAge}
                                removeRoom={removeRoom}
                                onAdultIncrease={onAdultIncrease}
                                onAdultDecrease={onAdultDecrease}
                                toggleGuestDetailsPopup={
                                  toggleGuestDetailsPopup
                                }
                                addRoom={addRoom}
                                addChildAge={addChildAge}
                                removeChild={removeChild}
                                availableAges={[2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
                              />
                            </div>
                          )}
                        </p>
                      </div>

                      <button
                        style={{ marginBottom: "10px" }}
                        type="submit"
                        className={styles.submitButton}
                      >
                        Modify
                        <span>
                          {" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                          >
                            <mask
                              id="mask0_6818_5962"
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="15"
                              height="15"
                            >
                              <rect width="15" height="15" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_6818_5962)">
                              <path
                                d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                                fill="white"
                              />
                            </g>
                          </svg>
                        </span>
                      </button>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className={styles.EditSearchFormParent}>
                <div className={styles.EditSearchFormChild}>
                  <div className={styles.EditSearchFormChildFirstDiv}>
                    <NewMultiSelectSearchHolidays
                      onClick={() => setdestinationToggle(true)}
                      onMultiSelectionChange={handleMultiDestinationsChange}
                      // selectedMultipleDestinations={selectedMultipleDestinations}
                      defaultSelected={selectedMultipleDestinations}
                      className={"search_form_input"}
                    />
                  </div>
                  <div
                    className={`${styles.EditSearchFormChildSecondDiv} new_date_picker_react_js_custom_styling`}
                  >
                    {/* <Flatpickr
                      style={{ fontWeight: "lighter" }}
                      className="testform_input"
                      value={[startDate, endDate]}
                      onChange={([date1, date2]) => {
                        setStartDate(date1 || null);
                        setEndDate(date2 || null);
                      }}
                      options={{
                        mode: "range",
                        minDate: "today", // Prevent selection of past dates
                      }}
                      required
                    /> */}

                    <DatePicker
                      showIcon
                      selected={startDate}
                      onChange={(dates) => {
                        const [start, end] = dates;
                        setStartDate(start);
                        setEndDate(end);
                      }}
                      startDate={startDate}
                      endDate={endDate}
                      selectsRange
                      portalId="root-portal NewUIReactDatePicker"
                      popperPlacement="bottom-start"
                      minDate={new Date()} // Prevent past dates selection
                      dateFormat="dd MMM, yyyy"
                      placeholderText={`${format(
                        startDate,
                        "dd MMM, yyyy"
                      )} - ${format(endDate, "dd MMM, yyyy")}`}
                    />
                  </div>
                  <div className={styles.EditSearchFormChildThirdDiv}>
                    <p
                      style={{ position: "relative" }}
                      className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                    >
                      <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                        <div className="optionCounter"></div>
                        <span id="adult_count">{adult}</span>
                        <span> Adults,</span>{" "}
                        <span id="room_count">{rooms}</span>
                        <span> Rooms, </span>{" "}
                        <span id="child_count">{children}</span>
                        <span> Children</span>
                      </div>
                      {guestDetails && (
                        <div ref={dropdownRef} className="popup-container">
                          <GuestDetailsPopup
                            setIsguestDetails={setIsguestDetails}
                            buttonName="Modify"
                            adult={adult}
                            setAdults={setAdults}
                            children={children}
                            setChildren={setChildren}
                            rooms={updatedStoreRoomsData}
                            setRooms={setUpdatedStoreRoomsData}
                            onRoomsChange={setUpdatedStoreRoomsData}
                            handleRoomsUpdate={setUpdatedStoreRoomsData}
                            setChildAge={setChildAge}
                            onAdultChange={setAdults}
                            childAge={childAge}
                            removeRoom={removeRoom}
                            onAdultIncrease={onAdultIncrease}
                            onAdultDecrease={onAdultDecrease}
                            toggleGuestDetailsPopup={toggleGuestDetailsPopup}
                            addRoom={addRoom}
                            addChildAge={addChildAge}
                            removeChild={removeChild}
                            availableAges={[2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
                          />
                        </div>
                      )}
                    </p>
                  </div>
                </div>
                <button type="submit" className={styles.submitButton}>
                  Modify
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <mask
                        id="mask0_6818_5962"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="15"
                        height="15"
                      >
                        <rect width="15" height="15" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_6818_5962)">
                        <path
                          d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </span>
                </button>
              </div>
            )}
          </form>
        )}
        {searchType === "all_hotels" && (
          <form
            action=""
            className={styles.EditSearchFormWrapper}
            id="main-form"
            // onSubmit={
            //   searchType === "hotel_listing"
            //     ? handleSubmitButtonClickHandlerListingHotels
            //     : handleSubmitButtonClickHandler
            // }
            onSubmit={handleSubmitButtonClickHandlerListingHotelsAllHotels}
          >
            {/* {width} */}
            {width <= 640 ? (
              <>
                {/* <div className={styles.EditSearchParentWrapperMobile}>
                <div className="flex_align_center">
                  <span onClick={() => window.history.back()}>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM1 9H16V7H1V9Z"
                        fill="#333333"
                      />
                    </svg>
                  </span>
                  <div className="SingleSearch-resp_content">
                    <h4 style={{ fontSize: "16px", lineHeight: "20px" }}>
                      {data?.fromCity ? (
                        capitalizeFirstLetter(data.fromCity)
                      ) : (
                        <p>Enter a destination</p>
                      )}
                    </h4>
                    <div style={{ fontSize: "14px", lineHeight: "20px" }}>
                      <span>{endDate}</span>
                      <span> | </span>
                      <span>
                        {adult} Adult, {children} Child
                      </span>
                    </div>
                  </div>
                </div>
                <div onClick={toggleModify}>
                  {modifyPkg ? (
                    <span style={{ marginRight: "10px" }}>X</span>
                  ) : (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_2797_7470"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_2797_7470)">
                        <path
                          d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM2.5 17.5V13.9583L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.04167 17.5H2.5ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z"
                          fill="#333333"
                        />
                      </g>
                    </svg>
                  )}
                </div>
              </div> */}

                <div className={styles.mobile_new_wrapper_container}>
                  <div
                    onClick={toggleModify}
                    className={styles.mobile_new_wrapper}
                  >
                    <div className={styles.mobile_new_left_div}>
                      <div>
                        {" "}
                        <SvgSearch />
                      </div>
                      <div className={styles.mobile_new_left_div_location}>
                        {data.fromCity &&
                          data.fromCity !== "" &&
                          data.fromCity != null &&
                          data.fromCity != "null" &&
                          capitalizeFirstLetter(data.fromCity) + ", "}
                        <span>
                          {getDateByMonth(startDate) +
                            " - " +
                            getDateByMonth(endDate) +
                            ""}
                        </span>
                      </div>
                    </div>

                    <div className={styles.mobile_new_right_div}>
                      <div className={styles.mobile_new_right_div_svg}>
                        <SvgMan />
                      </div>
                      <div className={styles.mobile_new_right_div_guest}>
                        {adult}
                      </div>
                    </div>
                  </div>

                  {modifyPkg && (
                    <div className={styles.lower_form}>
                      <div>
                        {/* <label htmlFor="">City/Destination</label> */}
                        {/* <GooglePlaceApi
                      setSelectedLocation={setSelectedLocation}
                      data={data}
                      defaultValue={data?.fromCity && data.fromCity}
                      setData={setData}
                      showErrorToast={showErrorToast}
                      position={"SingleSearchForm"}
                    /> */}
                        <label htmlFor="">City/Destination</label>
                        {/* <PackagesStateInputNewUi
                          onDataChange={getDataFromChild}
                          width={width}
                          // disableSearchInput={true}
                          
                        /> */}
                        <NewMultiSelectSearchHolidays
                          onClick={() => setdestinationToggle(true)}
                          onMultiSelectionChange={handleMultiDestinationsChange}
                          // selectedMultipleDestinations={selectedMultipleDestinations}
                          defaultSelected={selectedMultipleDestinations}
                          className={"search_form_input"}
                        />
                      </div>
                      <div className="new_date_picker_react_js_custom_styling">
                        <label>Check In - Check Out</label>
                        <DatePicker
                          selected={startDate}
                          onChange={(dates) => {
                            const [start, end] = dates;
                            setStartDate(start);
                            setEndDate(end);
                          }}
                          startDate={startDate}
                          endDate={endDate}
                          selectsRange
                          portalId="root-portal NewUIReactDatePicker"
                          popperPlacement="bottom-start"
                          minDate={new Date()} // Prevent past dates selection
                          dateFormat="dd MMM, yyyy"
                          placeholderText={`${format(
                            startDate,
                            "dd MMM, yyyy"
                          )} - ${format(endDate, "dd MMM, yyyy")}`}
                        />
                        {/* <input
                          className="testform_input"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          type="date"
                          required
                        />
                      </div>
                      <div className="">
                        <label>Check Out</label>
                        <input
                          className="testform_input"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          type="date"
                          required
                        /> */}
                      </div>
                      <div className="search_form_div p_0 icon_button_only">
                        <label
                          onClick={dropdownGuestDetails}
                          className="search_label"
                        >
                          Room & Guests{" "}
                          <svg
                            width="9"
                            height="5"
                            viewBox="0 0 9 5"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.25 0.75L4.75 4.25L1.25 0.75"
                              stroke="#BB735D"
                            />
                          </svg>
                        </label>
                        <p
                          style={{ position: "relative" }}
                          className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                        >
                          <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                            <div className="optionCounter"></div>
                            <span id="adult_count">{adult}</span>
                            <span> Adults,</span>{" "}
                            <span id="room_count">{rooms}</span>
                            <span> Rooms, </span>{" "}
                            <span id="child_count">{children}</span>
                            <span> Children</span>
                          </div>
                          {guestDetails && (
                            <div ref={dropdownRef} className="popup-container">
                              <GuestDetailsPopup
                                setIsguestDetails={setIsguestDetails}
                                buttonName="Modify"
                                adult={adult}
                                setAdults={setAdults}
                                children={children}
                                setChildren={setChildren}
                                rooms={updatedStoreRoomsData}
                                setRooms={setUpdatedStoreRoomsData}
                                onRoomsChange={setUpdatedStoreRoomsData}
                                handleRoomsUpdate={setUpdatedStoreRoomsData}
                                setChildAge={setChildAge}
                                onAdultChange={setAdults}
                                childAge={childAge}
                                removeRoom={removeRoom}
                                onAdultIncrease={onAdultIncrease}
                                onAdultDecrease={onAdultDecrease}
                                toggleGuestDetailsPopup={
                                  toggleGuestDetailsPopup
                                }
                                addRoom={addRoom}
                                addChildAge={addChildAge}
                                removeChild={removeChild}
                                availableAges={[2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
                              />
                            </div>
                          )}
                        </p>
                      </div>
                      <button
                        style={{ marginBottom: "10px" }}
                        type="submit"
                        className={styles.submitButton}
                      >
                        Modify
                        <span>
                          {" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                          >
                            <mask
                              id="mask0_6818_5962"
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="15"
                              height="15"
                            >
                              <rect width="15" height="15" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_6818_5962)">
                              <path
                                d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                                fill="white"
                              />
                            </g>
                          </svg>
                        </span>
                      </button>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className={styles.EditSearchFormParent}>
                <div className={styles.EditSearchFormChild}>
                  <div className={styles.EditSearchFormChildFirstDiv}>
                    <PackagesStateInputNewUi
                      onDataChange={getDataFromChild}
                      width={width}
                      // disableSearchInput={true}
                    />
                  </div>
                  <div
                    className={`${styles.EditSearchFormChildSecondDiv} new_date_picker_react_js_custom_styling`}
                  >
                    {/* <Flatpickr
                      style={{ fontWeight: "lighter" }}
                      className="testform_input"
                      value={[startDate, endDate]}
                      onChange={([date1, date2]) => {
                        setStartDate(date1 || null);
                        setEndDate(date2 || null);
                      }}
                      options={{
                        mode: "range",
                        minDate: "today", // Prevent selection of past dates
                      }}
                      required
                    /> */}

                    <DatePicker
                      selected={startDate}
                      onChange={(dates) => {
                        const [start, end] = dates;
                        setStartDate(start);
                        setEndDate(end);
                      }}
                      startDate={startDate}
                      endDate={endDate}
                      selectsRange
                      portalId="root-portal NewUIReactDatePicker"
                      popperPlacement="bottom-start"
                      minDate={new Date()} // Prevent past dates selection
                      dateFormat="dd MMM, yyyy"
                      placeholderText={`${format(
                        startDate,
                        "dd MMM, yyyy"
                      )} - ${format(endDate, "dd MMM, yyyy")}`}
                    />
                  </div>
                  <div className={styles.EditSearchFormChildThirdDiv}>
                    <p
                      style={{ position: "relative" }}
                      className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                    >
                      <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                        <div className="optionCounter"></div>
                        <span id="adult_count">{adult}</span>
                        <span> Adults,</span>{" "}
                        <span id="room_count">{rooms}</span>
                        <span> Rooms, </span>{" "}
                        <span id="child_count">{children}</span>
                        <span> Children</span>
                      </div>
                      {guestDetails && (
                        <div ref={dropdownRef} className="popup-container">
                          <GuestDetailsPopup
                            setIsguestDetails={setIsguestDetails}
                            buttonName="Modify"
                            adult={adult}
                            setAdults={setAdults}
                            children={children}
                            setChildren={setChildren}
                            rooms={updatedStoreRoomsData}
                            setRooms={setUpdatedStoreRoomsData}
                            onRoomsChange={setUpdatedStoreRoomsData}
                            handleRoomsUpdate={setUpdatedStoreRoomsData}
                            setChildAge={setChildAge}
                            onAdultChange={setAdults}
                            childAge={childAge}
                            removeRoom={removeRoom}
                            onAdultIncrease={onAdultIncrease}
                            onAdultDecrease={onAdultDecrease}
                            toggleGuestDetailsPopup={toggleGuestDetailsPopup}
                            addRoom={addRoom}
                            addChildAge={addChildAge}
                            removeChild={removeChild}
                            availableAges={[2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
                          />
                        </div>
                      )}
                    </p>
                  </div>
                </div>
                <button type="submit" className={styles.submitButton}>
                  Modify
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <mask
                        id="mask0_6818_5962"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="15"
                        height="15"
                      >
                        <rect width="15" height="15" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_6818_5962)">
                        <path
                          d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </span>
                </button>
              </div>
            )}
          </form>
        )}
        {searchType === "single_hotel" && (
          <form
            action=""
            className={styles.EditSearchFormWrapper}
            id="main-form"
            onSubmit={handleSubmitButtonSingleHotel}
          >
            {/* {width} */}
            {width <= 640 ? (
              <div className={styles.mobile_new_wrapper_container}>
                <div
                  onClick={toggleModify}
                  className={styles.mobile_new_wrapper}
                >
                  <div className={styles.mobile_new_left_div}>
                    <div>
                      {" "}
                      <SvgSearch />
                    </div>
                    <div className={styles.mobile_new_left_div_location}>
                      {data.fromCity &&
                        data.fromCity !== "" &&
                        data.fromCity != null &&
                        data.fromCity != "null" &&
                        capitalizeFirstLetter(data.fromCity) + ", "}
                      <span>
                        {getDateByMonth(startDate) +
                          " - " +
                          getDateByMonth(endDate) +
                          ""}
                      </span>
                    </div>
                  </div>

                  <div className={styles.mobile_new_right_div}>
                    <div className={styles.mobile_new_right_div_svg}>
                      <SvgMan />
                    </div>
                    <div className={styles.mobile_new_right_div_guest}>
                      {adult}
                    </div>
                  </div>
                </div>
                {modifyPkg && (
                  <div className={styles.lower_form}>
                    {/* <div>
               
                    <label htmlFor="">City/Destination</label>
                    <PackagesStateInputNewUi
                      onDataChange={getDataFromChild}
                      width={width}
                      disableSearchInput={true}
                    />
                  </div> */}
                    <div className="new_date_picker_react_js_custom_styling">
                      <label>Check In - Check Out</label>
                      <DatePicker
                        selected={startDate}
                        onChange={(dates) => {
                          const [start, end] = dates;
                          setStartDate(start);
                          setEndDate(end);
                        }}
                        startDate={startDate}
                        endDate={endDate}
                        selectsRange
                        portalId="root-portal NewUIReactDatePicker"
                        popperPlacement="bottom-start"
                        minDate={new Date()} // Prevent past dates selection
                        dateFormat="dd MMM, yyyy"
                        placeholderText={`${format(
                          startDate,
                          "dd MMM, yyyy"
                        )} - ${format(endDate, "dd MMM, yyyy")}`}
                      />
                      {/* <input
                        className="testform_input"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        type="date"
                        required
                      />
                    </div>
                    <div className="">
                      <label>Check Out</label>
                      <input
                        className="testform_input"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        type="date"
                        required
                      /> */}
                    </div>
                    <div className="search_form_div p_0 icon_button_only">
                      <label
                        onClick={dropdownGuestDetails}
                        className="search_label"
                      >
                        Room & Guests{" "}
                        <svg
                          width="9"
                          height="5"
                          viewBox="0 0 9 5"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.25 0.75L4.75 4.25L1.25 0.75"
                            stroke="#BB735D"
                          />
                        </svg>
                      </label>
                      <p
                        style={{ position: "relative" }}
                        className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                      >
                        <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                          <div className="optionCounter"></div>
                          <span id="adult_count">{adult}</span>
                          <span> Adults,</span>{" "}
                          <span id="room_count">{rooms}</span>
                          <span> Rooms, </span>{" "}
                          <span id="child_count">{children}</span>
                          <span> Children</span>
                        </div>
                        {guestDetails && (
                          <div ref={dropdownRef} className="popup-container">
                            <GuestDetailsPopup
                              setIsguestDetails={setIsguestDetails}
                              buttonName="Modify"
                              adult={adult}
                              setAdults={setAdults}
                              children={children}
                              setChildren={setChildren}
                              rooms={updatedStoreRoomsData}
                              setRooms={setUpdatedStoreRoomsData}
                              onRoomsChange={setUpdatedStoreRoomsData}
                              handleRoomsUpdate={setUpdatedStoreRoomsData}
                              setChildAge={setChildAge}
                              onAdultChange={setAdults}
                              childAge={childAge}
                              removeRoom={removeRoom}
                              onAdultIncrease={onAdultIncrease}
                              onAdultDecrease={onAdultDecrease}
                              toggleGuestDetailsPopup={toggleGuestDetailsPopup}
                              addRoom={addRoom}
                              addChildAge={addChildAge}
                              removeChild={removeChild}
                              availableAges={[2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
                            />
                          </div>
                        )}
                      </p>
                    </div>
                    <button
                      // style={{ marginBottom: "10px" }}
                      type="submit"
                      className={styles.submitButton}
                    >
                      Modify
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <mask
                            id="mask0_6818_5962"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="15"
                            height="15"
                          >
                            <rect width="15" height="15" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_6818_5962)">
                            <path
                              d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                              fill="white"
                            />
                          </g>
                        </svg>
                      </span>
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className={styles.EditSearchFormParent}>
                <div className={styles.EditSearchFormChild}>
                  {/* <div className={styles.EditSearchFormChildFirstDiv}>
                    <PackagesStateInputNewUi
                      onDataChange={getDataFromChild}
                      // disableSearchInput={true}
                      width={width}
                    />
                  </div> */}
                  <div
                    className={`${styles.EditSearchFormChildSecondDiv} new_date_picker_react_js_custom_styling`}
                  >
                    {/* <Flatpickr
                      style={{ fontWeight: "lighter" }}
                      className="testform_input"
                      value={[startDate, endDate]}
                      onChange={([date1, date2]) => {
                        setStartDate(date1 || null);
                        setEndDate(date2 || null);
                      }}
                      options={{
                        mode: "range",
                        minDate: "today", // Prevent selection of past dates
                      }}
                      required
                    /> */}

                    <DatePicker
                      selected={startDate}
                      onChange={(dates) => {
                        const [start, end] = dates;
                        setStartDate(start);
                        setEndDate(end);
                      }}
                      startDate={startDate}
                      endDate={endDate}
                      selectsRange
                      portalId="root-portal NewUIReactDatePicker"
                      popperPlacement="bottom-start"
                      minDate={new Date()} // Prevent past dates selection
                      dateFormat="dd MMM, yyyy"
                      placeholderText={`${format(
                        startDate,
                        "dd MMM, yyyy"
                      )} - ${format(endDate, "dd MMM, yyyy")}`}
                    />
                  </div>
                  <div className={styles.EditSearchFormChildThirdDiv}>
                    <p
                      style={{ position: "relative" }}
                      className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
                    >
                      <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                        <div className="optionCounter"></div>
                        <span id="adult_count">{adult}</span>
                        <span> Adults,</span>{" "}
                        <span id="room_count">{rooms}</span>
                        <span> Rooms, </span>{" "}
                        <span id="child_count">{children}</span>
                        <span> Children</span>
                      </div>
                      {guestDetails && (
                        <div ref={dropdownRef} className="popup-container">
                          <GuestDetailsPopup
                            setIsguestDetails={setIsguestDetails}
                            buttonName="Modify"
                            adult={adult}
                            setAdults={setAdults}
                            children={children}
                            setChildren={setChildren}
                            rooms={updatedStoreRoomsData}
                            setRooms={setUpdatedStoreRoomsData}
                            onRoomsChange={setUpdatedStoreRoomsData}
                            handleRoomsUpdate={setUpdatedStoreRoomsData}
                            setChildAge={setChildAge}
                            onAdultChange={setAdults}
                            childAge={childAge}
                            removeRoom={removeRoom}
                            onAdultIncrease={onAdultIncrease}
                            onAdultDecrease={onAdultDecrease}
                            toggleGuestDetailsPopup={toggleGuestDetailsPopup}
                            addRoom={addRoom}
                            addChildAge={addChildAge}
                            removeChild={removeChild}
                            availableAges={[2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
                          />
                        </div>
                      )}
                    </p>
                  </div>
                </div>
                <button type="submit" className={styles.submitButton}>
                  Modify
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <mask
                        id="mask0_6818_5962"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="15"
                        height="15"
                      >
                        <rect width="15" height="15" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_6818_5962)">
                        <path
                          d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </span>
                </button>
              </div>
            )}
          </form>
        )}

        <input type="hidden" name="hotelId" value="{{ $hotelId }}" />
      </div>
    </section>
  );
}

export default EditNewUiSearchFormHotels;

// <form
//   action=""
//   className={styles.EditSearchFormWrapper}
//   id="main-form"
//   onSubmit={handleSubmitButtonClickHandlerListingHotels}
// >
//   {/* {width} */}
//   {width <= 640 ? (
//     <>
//       <div className={styles.EditSearchParentWrapperMobile}>
//         <div className="flex_align_center">
//           <span onClick={() => window.history.back()}>
//             <svg
//               width="16"
//               height="16"
//               viewBox="0 0 16 16"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM1 9H16V7H1V9Z"
//                 fill="#333333"
//               />
//             </svg>
//           </span>
//           <div className="SingleSearch-resp_content">
//             <h4 style={{ fontSize: "16px", lineHeight: "20px" }}>
//               {data?.fromCity ? (
//                 capitalizeFirstLetter(data.fromCity)
//               ) : (
//                 <p>Enter a destination</p>
//               )}
//             </h4>
//             <div style={{ fontSize: "14px", lineHeight: "20px" }}>
//               <span>{endDate}</span>
//               <span> | </span>
//               <span>
//                 {adult} Adult, {children} Child
//               </span>
//             </div>
//           </div>
//         </div>
//         <div onClick={toggleModify}>
//           {modifyPkg ? (
//             <span style={{ marginRight: "10px" }}>X</span>
//           ) : (
//             <svg
//               width="20"
//               height="20"
//               viewBox="0 0 20 20"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <mask
//                 id="mask0_2797_7470"
//                 style={{ maskType: "alpha" }}
//                 maskUnits="userSpaceOnUse"
//                 x="0"
//                 y="0"
//                 width="20"
//                 height="20"
//               >
//                 <rect width="20" height="20" fill="#D9D9D9" />
//               </mask>
//               <g mask="url(#mask0_2797_7470)">
//                 <path
//                   d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM2.5 17.5V13.9583L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.04167 17.5H2.5ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z"
//                   fill="#333333"
//                 />
//               </g>
//             </svg>
//           )}
//         </div>
//       </div>
//       {modifyPkg && (
//         <>
//           <div>
//             {/* <label htmlFor="">City/Destination</label> */}
//             {/* <GooglePlaceApi
//               setSelectedLocation={setSelectedLocation}
//               data={data}
//               defaultValue={data?.fromCity && data.fromCity}
//               setData={setData}
//               showErrorToast={showErrorToast}
//               position={"SingleSearchForm"}
//             /> */}
//             <PackagesStateInputNewUi
//               onDataChange={getDataFromChild}
//               width={width}
//               // disableSearchInput={true}
//             />
//           </div>
//           <div className="">
//             <label>Check In</label>
//             <input
//               className="testform_input"
//               value={startDate}
//               onChange={(e) => setStartDate(e.target.value)}
//               type="date"
//               required
//             />
//           </div>
//           <div className="">
//             <label>Check Out</label>
//             <input
//               className="testform_input"
//               value={endDate}
//               onChange={(e) => setEndDate(e.target.value)}
//               type="date"
//               required
//             />
//           </div>
//           <div className="search_form_div p_0 icon_button_only">
//             {/* <label
//                 onClick={dropdownGuestDetails}
//                 className="search_label"
//               >
//                 Room & Guests{" "}
//                 <svg
//                   width="9"
//                   height="5"
//                   viewBox="0 0 9 5"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     d="M8.25 0.75L4.75 4.25L1.25 0.75"
//                     stroke="#BB735D"
//                   />
//                 </svg>
//               </label> */}
//             <p
//               style={{ position: "relative" }}
//               className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
//             >
//               <div onClick={dropdownGuestDetails} ref={dropdownRef}>
//                 <div className="optionCounter"></div>
//                 <span id="adult_count">{adult}</span>
//                 <span> Adults,</span>{" "}
//                 <span id="room_count">{rooms}</span>
//                 <span> Rooms, </span>{" "}
//                 <span id="child_count">{children}</span>
//                 <span> Children</span>
//               </div>
//               {guestDetails && (
//                 <div
//                   className="guest_details_dropdown"
//                   id="guestDetailsPopup"
//                   ref={popupsRef}
//                 >
//                   <div className="agent">
//                     <span>Adult</span>
//                     <div>
//                       <button
//                         type="button"
//                         disabled={adult <= 1}
//                         className="optionCounterButton optionCounterButtonWithBorder"
//                         onClick={onAdultDecrease}
//                       >
//                         <span
//                           className="onclick_btn"
//                           id="adult_minus"
//                         >
//                           -
//                         </span>
//                       </button>

//                       <input
//                         className="optionCounterNumber"
//                         value={adult}
//                         min={1}
//                       />

//                       <button
//                         type="button"
//                         // disabled={rooms <= 1}
//                         className="optionCounterButton optionCounterButtonWithBorder"
//                         onClick={onAdultIncrease}
//                       >
//                         <span className="onclick_btn" id="adult_plus">
//                           +
//                         </span>
//                       </button>
//                     </div>
//                   </div>
//                   <div className="agent">
//                     <span>Rooms</span>
//                     <div>
//                       <button
//                         type="button"
//                         disabled={rooms <= 1}
//                         className="optionCounterButton optionCounterButtonWithBorder"
//                         onClick={() => setRooms(Number(rooms) - 1)}
//                       >
//                         <span
//                           className="onclick_btn"
//                           id="adult_minus"
//                         >
//                           -
//                         </span>
//                       </button>

//                       <input
//                         className="optionCounterNumber"
//                         value={rooms}
//                         min={1}
//                       />

//                       <button
//                         type="button"
//                         // disabled={rooms <= 1}
//                         className="optionCounterButton optionCounterButtonWithBorder"
//                         onClick={() => setRooms(Number(rooms) + 1)}
//                       >
//                         <span className="onclick_btn" id="adult_plus">
//                           +
//                         </span>
//                       </button>
//                     </div>
//                   </div>
//                   <div>
//                     {childAge.map((age, index) => (
//                       <div
//                         className="agent flex items-center gap-2"
//                         key={index}
//                       >
//                         <span>
//                           Child{" "}
//                           <small style={{ fontSize: "12px" }}>
//                             {" "}
//                             ({age} Yrs){" "}
//                           </small>
//                         </span>
//                         <div
//                           className="remove_svg"
//                           onClick={() => handleRemoveChild(index)}
//                         >
//                           <svg
//                             width="18"
//                             height="18"
//                             viewBox="0 0 18 18"
//                             fill="none"
//                             xmlns="http://www.w3.org/2000/svg"
//                           >
//                             <mask
//                               id="mask0_6577_13294"
//                               style={{ maskType: "alpha" }}
//                               maskUnits="userSpaceOnUse"
//                               x="0"
//                               y="0"
//                               width="18"
//                               height="18"
//                             >
//                               <rect width="18" height="18" />
//                             </mask>
//                             <g mask="url(#mask0_6577_13294)">
//                               <path d="M6.3 12.4903L9 9.79031L11.7 12.4903L12.4903 11.7L9.79031 9L12.4903 6.3L11.7 5.50969L9 8.20969L6.3 5.50969L5.50969 6.3L8.20969 9L5.50969 11.7L6.3 12.4903ZM9.00131 16.125C8.01581 16.125 7.0895 15.938 6.22237 15.564C5.35525 15.19 4.601 14.6824 3.95962 14.0413C3.31825 13.4002 2.81044 12.6463 2.43619 11.7795C2.06206 10.9128 1.875 9.98669 1.875 9.00131C1.875 8.01581 2.062 7.0895 2.436 6.22237C2.81 5.35525 3.31756 4.601 3.95869 3.95962C4.59981 3.31825 5.35375 2.81044 6.2205 2.43619C7.08725 2.06206 8.01331 1.875 8.99869 1.875C9.98419 1.875 10.9105 2.062 11.7776 2.436C12.6448 2.81 13.399 3.31756 14.0404 3.95869C14.6818 4.59981 15.1896 5.35375 15.5638 6.2205C15.9379 7.08725 16.125 8.01331 16.125 8.99869C16.125 9.98419 15.938 10.9105 15.564 11.7776C15.19 12.6448 14.6824 13.399 14.0413 14.0404C13.4002 14.6818 12.6463 15.1896 11.7795 15.5638C10.9128 15.9379 9.98669 16.125 9.00131 16.125Z" />
//                             </g>
//                           </svg>
//                         </div>
//                       </div>
//                     ))}

//                     {/* Add a child button */}
//                     <div
//                       className="flex align_items_center justify_content_between border"
//                       style={{
//                         padding: "10px ",
//                         marginBottom: "10px",
//                         fontWeight: "400",
//                       }}
//                       onClick={() =>
//                         setShowGuestDetailsPopup(
//                           !showGuestDetailsPopup
//                         )
//                       }
//                     >
//                       Add a Child
//                       <div>
//                         <svg
//                           width="12"
//                           height="6"
//                           viewBox="0 0 12 6"
//                           fill="none"
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <path
//                             d="M5.99982 4.64202L10.3939 0.247911C10.5098 0.132021 10.6463 0.0755358 10.8033 0.0784526C10.9604 0.0814662 11.0969 0.140917 11.2128 0.256806C11.3287 0.372792 11.3866 0.509293 11.3866 0.666307C11.3866 0.82332 11.3287 0.95982 11.2128 1.07581L6.74693 5.55056C6.64144 5.65604 6.52327 5.73421 6.39241 5.78506C6.26155 5.8359 6.13069 5.86133 5.99983 5.86133C5.86896 5.86133 5.7381 5.8359 5.60724 5.78506C5.47638 5.73421 5.35821 5.65604 5.25272 5.55056L0.777825 1.07581C0.661936 0.959821 0.605499 0.821814 0.608513 0.661786C0.611527 0.501759 0.670978 0.3638 0.786867 0.247911C0.902756 0.132022 1.03926 0.0740781 1.19637 0.0740781C1.35338 0.0740781 1.48983 0.132022 1.60572 0.247911L5.99982 4.64202Z"
//                             fill="#1C1B1F"
//                           />
//                         </svg>
//                       </div>
//                     </div>

//                     {/* Child age selection popup */}
//                     {showGuestDetailsPopup && (
//                       <div className="new_guest_details_popup mt-2 bg-white p-4 shadow-lg rounded-lg">
//                         {availableAges.map((age, i) => (
//                           <div
//                             className="new-age-option"
//                             key={i}
//                             onClick={() => handleAddChildAge(age)}
//                             style={{ fontWeight: "400" }}
//                           >
//                             {age} Years
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}
//             </p>
//           </div>
//           <button
//             style={{ marginBottom: "10px" }}
//             type="submit"
//             className={styles.submitButton}
//           >
//             Modify
//             <span>
//               {" "}
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="17"
//                 height="12"
//                 viewBox="0 0 17 12"
//                 fill="none"
//               >
//                 <g clipPath="url(#clip0_6093_5578)">
//                   <path
//                     d="M16.5488 5.27416C12.5086 4.76301 11.0605 0.540892 11.0395 0.5L10.0426 0.816914C10.0951 0.980483 11.1235 3.97584 13.9253 5.48885H0V6.51115H13.9253C11.134 8.02416 10.0951 11.0297 10.0426 11.1831L11.0395 11.5C11.0395 11.5 12.5086 7.23699 16.5488 6.72584L17.0105 6.6645V5.32528L16.5488 5.26394V5.27416Z"
//                     fill="white"
//                   />
//                 </g>
//                 <defs>
//                   <clipPath id="clip0_6093_5578">
//                     <rect
//                       width="17"
//                       height="11"
//                       fill="white"
//                       transform="translate(0 0.5)"
//                     />
//                   </clipPath>
//                 </defs>
//               </svg>
//             </span>
//           </button>
//         </>
//       )}
//     </>
//   ) : (
//     <div className={styles.EditSearchFormParent}>
//       <div className={styles.EditSearchFormChild}>
//         <div className={styles.EditSearchFormChildFirstDiv}>
//           <PackagesStateInputNewUi
//             onDataChange={getDataFromChild}
//             disableSearchInput={false}
//             width={width}
//           />
//         </div>
//         <div className={styles.EditSearchFormChildSecondDiv}>
//           <Flatpickr
//             style={{ fontWeight: "lighter" }}
//             className="testform_input"
//             value={[startDate, endDate]}
//             onChange={([date1, date2]) => {
//               setStartDate(date1 || null);
//               setEndDate(date2 || null);
//             }}
//             options={{
//               mode: "range",
//               minDate: "today", // Prevent selection of past dates
//             }}
//             required
//           />
//         </div>
//         <div className={styles.EditSearchFormChildThirdDiv}>
//           <p
//             style={{ position: "relative" }}
//             className="SingleSearch-Guests dropdown-toggle search_form_input testform_input"
//           >
//             <div onClick={dropdownGuestDetails} ref={dropdownRef}>
//               <div className="optionCounter"></div>
//               <span id="adult_count">{adult}</span>
//               <span> Adults,</span>{" "}
//               <span id="room_count">{rooms}</span>
//               <span> Rooms, </span>{" "}
//               <span id="child_count">{children}</span>
//               <span> Children</span>
//             </div>
//             {guestDetails && (
//               <div
//                 className="guest_details_dropdown"
//                 id="guestDetailsPopup"
//                 ref={popupsRef}
//               >
//                 <div className="agent">
//                   <span>Adult</span>
//                   <div>
//                     <button
//                       type="button"
//                       disabled={adult <= 1}
//                       className="optionCounterButton optionCounterButtonWithBorder"
//                       onClick={onAdultDecrease}
//                     >
//                       <span className="onclick_btn" id="adult_minus">
//                         -
//                       </span>
//                     </button>

//                     <input
//                       className="optionCounterNumber"
//                       value={adult}
//                       min={1}
//                     />

//                     <button
//                       type="button"
//                       // disabled={rooms <= 1}
//                       className="optionCounterButton optionCounterButtonWithBorder"
//                       onClick={onAdultIncrease}
//                     >
//                       <span className="onclick_btn" id="adult_plus">
//                         +
//                       </span>
//                     </button>
//                   </div>
//                 </div>
//                 <div className="agent">
//                   <span>Rooms</span>
//                   <div>
//                     <button
//                       type="button"
//                       disabled={rooms <= 1}
//                       className="optionCounterButton optionCounterButtonWithBorder"
//                       onClick={() => setRooms(Number(rooms) - 1)}
//                     >
//                       <span className="onclick_btn" id="adult_minus">
//                         -
//                       </span>
//                     </button>

//                     <input
//                       className="optionCounterNumber"
//                       value={rooms}
//                       min={1}
//                     />

//                     <button
//                       type="button"
//                       // disabled={rooms <= 1}
//                       className="optionCounterButton optionCounterButtonWithBorder"
//                       onClick={() => setRooms(Number(rooms) + 1)}
//                     >
//                       <span className="onclick_btn" id="adult_plus">
//                         +
//                       </span>
//                     </button>
//                   </div>
//                 </div>
//                 <div>
//                   {childAge.map((age, index) => (
//                     <div
//                       className="agent flex items-center gap-2"
//                       key={index}
//                     >
//                       <span>
//                         Child{" "}
//                         <small style={{ fontSize: "12px" }}>
//                           {" "}
//                           ({age} Yrs){" "}
//                         </small>
//                       </span>
//                       <div
//                         className="remove_svg"
//                         onClick={() => handleRemoveChild(index)}
//                       >
//                         <svg
//                           width="18"
//                           height="18"
//                           viewBox="0 0 18 18"
//                           fill="none"
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <mask
//                             id="mask0_6577_13294"
//                             style={{ maskType: "alpha" }}
//                             maskUnits="userSpaceOnUse"
//                             x="0"
//                             y="0"
//                             width="18"
//                             height="18"
//                           >
//                             <rect width="18" height="18" />
//                           </mask>
//                           <g mask="url(#mask0_6577_13294)">
//                             <path d="M6.3 12.4903L9 9.79031L11.7 12.4903L12.4903 11.7L9.79031 9L12.4903 6.3L11.7 5.50969L9 8.20969L6.3 5.50969L5.50969 6.3L8.20969 9L5.50969 11.7L6.3 12.4903ZM9.00131 16.125C8.01581 16.125 7.0895 15.938 6.22237 15.564C5.35525 15.19 4.601 14.6824 3.95962 14.0413C3.31825 13.4002 2.81044 12.6463 2.43619 11.7795C2.06206 10.9128 1.875 9.98669 1.875 9.00131C1.875 8.01581 2.062 7.0895 2.436 6.22237C2.81 5.35525 3.31756 4.601 3.95869 3.95962C4.59981 3.31825 5.35375 2.81044 6.2205 2.43619C7.08725 2.06206 8.01331 1.875 8.99869 1.875C9.98419 1.875 10.9105 2.062 11.7776 2.436C12.6448 2.81 13.399 3.31756 14.0404 3.95869C14.6818 4.59981 15.1896 5.35375 15.5638 6.2205C15.9379 7.08725 16.125 8.01331 16.125 8.99869C16.125 9.98419 15.938 10.9105 15.564 11.7776C15.19 12.6448 14.6824 13.399 14.0413 14.0404C13.4002 14.6818 12.6463 15.1896 11.7795 15.5638C10.9128 15.9379 9.98669 16.125 9.00131 16.125Z" />
//                           </g>
//                         </svg>
//                       </div>
//                     </div>
//                   ))}

//                   {/* Add a child button */}
//                   <div
//                     className="flex align_items_center justify_content_between border"
//                     style={{
//                       padding: "10px ",
//                       marginBottom: "10px",
//                       fontWeight: "400",
//                     }}
//                     onClick={() =>
//                       setShowGuestDetailsPopup(!showGuestDetailsPopup)
//                     }
//                   >
//                     Add a Child
//                     <div>
//                       <svg
//                         width="12"
//                         height="6"
//                         viewBox="0 0 12 6"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M5.99982 4.64202L10.3939 0.247911C10.5098 0.132021 10.6463 0.0755358 10.8033 0.0784526C10.9604 0.0814662 11.0969 0.140917 11.2128 0.256806C11.3287 0.372792 11.3866 0.509293 11.3866 0.666307C11.3866 0.82332 11.3287 0.95982 11.2128 1.07581L6.74693 5.55056C6.64144 5.65604 6.52327 5.73421 6.39241 5.78506C6.26155 5.8359 6.13069 5.86133 5.99983 5.86133C5.86896 5.86133 5.7381 5.8359 5.60724 5.78506C5.47638 5.73421 5.35821 5.65604 5.25272 5.55056L0.777825 1.07581C0.661936 0.959821 0.605499 0.821814 0.608513 0.661786C0.611527 0.501759 0.670978 0.3638 0.786867 0.247911C0.902756 0.132022 1.03926 0.0740781 1.19637 0.0740781C1.35338 0.0740781 1.48983 0.132022 1.60572 0.247911L5.99982 4.64202Z"
//                           fill="#1C1B1F"
//                         />
//                       </svg>
//                     </div>
//                   </div>

//                   {/* Child age selection popup */}
//                   {showGuestDetailsPopup && (
//                     <div className="new_guest_details_popup mt-2 bg-white p-4 shadow-lg rounded-lg">
//                       {availableAges.map((age, i) => (
//                         <div
//                           className="new-age-option"
//                           key={i}
//                           onClick={() => handleAddChildAge(age)}
//                           style={{ fontWeight: "400" }}
//                         >
//                           {age} Years
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </p>
//         </div>
//       </div>
//       <button type="submit" className={styles.submitButton}>
//         Modify
//         <span>
//           {" "}
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="17"
//             height="12"
//             viewBox="0 0 17 12"
//             fill="none"
//           >
//             <g clipPath="url(#clip0_6093_5578)">
//               <path
//                 d="M16.5488 5.27416C12.5086 4.76301 11.0605 0.540892 11.0395 0.5L10.0426 0.816914C10.0951 0.980483 11.1235 3.97584 13.9253 5.48885H0V6.51115H13.9253C11.134 8.02416 10.0951 11.0297 10.0426 11.1831L11.0395 11.5C11.0395 11.5 12.5086 7.23699 16.5488 6.72584L17.0105 6.6645V5.32528L16.5488 5.26394V5.27416Z"
//                 fill="white"
//               />
//             </g>
//             <defs>
//               <clipPath id="clip0_6093_5578">
//                 <rect
//                   width="17"
//                   height="11"
//                   fill="white"
//                   transform="translate(0 0.5)"
//                 />
//               </clipPath>
//             </defs>
//           </svg>
//         </span>
//       </button>
//     </div>
//   )}
// </form>
